import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-gradient-to-br from-red-50 to-slate-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 border-2 border-red-100" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4" }
const _hoisted_3 = { class: "md:col-span-2 lg:col-span-3" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "flex items-center gap-3 md:col-span-2 lg:col-span-3" }
const _hoisted_6 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = { class: "md:col-span-2 lg:col-span-3" }
const _hoisted_9 = { class: "text-slate-500 text-xs mt-1" }

import { computed } from "vue";

interface Option {
  label: string;
  value: string;
}

interface Props {
  nombreProducto: string;
  descripcionProducto: string;
  idMarca: string;
  idCategoria: string;
  // idProveedor: string;
  precioProducto: number | null | undefined;
  stockProducto: number | null | undefined;
  isDestacado: number | undefined;
  touched: Record<string, boolean>;
  validaciones: Record<string, string[]>;
  marcas: Option[];
  categorias: Option[];
  // proveedores: Option[];
}

type FieldKey =
  | "nombre"
  | "descripcion"
  | "marca"
  | "categoria"
  // | "proveedor"
  | "precio"
  | "stock";

interface Emits {
  (e: "update:nombreProducto", value: string): void;
  (e: "update:descripcionProducto", value: string): void;
  (e: "update:idMarca", value: string): void;
  (e: "update:idCategoria", value: string): void;
  // (e: "update:idProveedor", value: string): void;
  (e: "update:precioProducto", value: number | null | undefined): void;
  (e: "update:stockProducto", value: number | null | undefined): void;
  (e: "update:isDestacado", value: number | undefined): void;
  (e: "blur", field: FieldKey): void; // 🔥 ahora tipado correctamente
}



export default /*@__PURE__*/_defineComponent({
  __name: 'InformacionBasica',
  props: {
    nombreProducto: {},
    descripcionProducto: {},
    idMarca: {},
    idCategoria: {},
    precioProducto: {},
    stockProducto: {},
    isDestacado: {},
    touched: {},
    validaciones: {},
    marcas: {},
    categorias: {}
  },
  emits: ["update:nombreProducto", "update:descripcionProducto", "update:idMarca", "update:idCategoria", "update:precioProducto", "update:stockProducto", "update:isDestacado", "blur"],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable vue/valid-define-props */
const props = __props;
const emit = __emit;

// Computed con v-model bidireccional
const nombreProductoLocal = computed({
  get: () => props.nombreProducto,
  set: (val) => emit("update:nombreProducto", val),
});

const descripcionProductoLocal = computed({
  get: () => props.descripcionProducto,
  set: (val) => emit("update:descripcionProducto", val),
});

const idMarcaLocal = computed({
  get: () => props.idMarca,
  set: (val) => emit("update:idMarca", val),
});

const idCategoriaLocal = computed({
  get: () => props.idCategoria,
  set: (val) => emit("update:idCategoria", val),
});

// const idProveedorLocal = computed({
//   get: () => props.idProveedor,
//   set: (val) => emit("update:idProveedor", val),
// });

const precioProductoLocal = computed({
  get: () => props.precioProducto,
  set: (val) => emit("update:precioProducto", val),
});

const stockProductoLocal = computed({
  get: () => props.stockProducto,
  set: (val) => emit("update:stockProducto", val),
});

const isDestacadoLocal = computed({
  get: () => props.isDestacado,
  set: (val) => emit("update:isDestacado", val),
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6\" data-v-a09b8a96><div class=\"bg-red-600 p-2 sm:p-2.5 rounded-lg\" data-v-a09b8a96><svg class=\"w-5 h-5 sm:w-6 sm:h-6 text-white\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-a09b8a96><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z\" data-v-a09b8a96></path></svg></div><h3 class=\"text-lg sm:text-xl font-bold text-slate-800\" data-v-a09b8a96> Información Básica </h3></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block font-semibold text-slate-700 mb-2 text-sm sm:text-base" }, [
          _createTextVNode(" Nombre del producto "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nombreProductoLocal).value = $event)),
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (emit('blur', 'nombre'))),
          class: "w-full px-3 sm:px-4 py-2 sm:py-2.5 text-sm sm:text-base border-2 rounded-lg sm:rounded-xl focus:border-red-500 focus:outline-none transition-colors",
          placeholder: "Ej: Filtro de aceite premium"
        }, null, 544), [
          [_vModelText, nombreProductoLocal.value]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.validaciones.nombre, (error) => {
          return (_openBlock(), _createElementBlock("p", {
            key: error,
            class: "text-red-500 text-xs sm:text-sm mt-1"
          }, _toDisplayString(error), 1))
        }), 128))
      ]),
      _createElementVNode("div", null, [
        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block font-semibold text-slate-700 mb-2 text-sm sm:text-base" }, [
          _createTextVNode(" Marca de producto"),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _createVNode(_component_v_select, {
          modelValue: idMarcaLocal.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((idMarcaLocal).value = $event)),
          options: __props.marcas,
          reduce: (option) => option.value,
          label: "label",
          placeholder: "Selecciona...",
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (emit('blur', 'marca'))),
          "append-to-body": true,
          class: "custom-v-select"
        }, null, 8, ["modelValue", "options", "reduce"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.validaciones.marca, (error) => {
          return (_openBlock(), _createElementBlock("p", {
            key: error,
            class: "text-red-500 text-xs sm:text-sm mt-1"
          }, _toDisplayString(error), 1))
        }), 128))
      ]),
      _createElementVNode("div", null, [
        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block font-semibold text-slate-700 mb-2 text-sm sm:text-base" }, [
          _createTextVNode(" Categoría "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _createVNode(_component_v_select, {
          modelValue: idCategoriaLocal.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((idCategoriaLocal).value = $event)),
          options: __props.categorias,
          reduce: (option) => option.value,
          label: "label",
          placeholder: "Selecciona...",
          onBlur: _cache[5] || (_cache[5] = ($event: any) => (emit('blur', 'categoria'))),
          "append-to-body": true,
          class: "custom-v-select"
        }, null, 8, ["modelValue", "options", "reduce"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.validaciones.categoria, (error) => {
          return (_openBlock(), _createElementBlock("p", {
            key: error,
            class: "text-red-500 text-xs sm:text-sm mt-1"
          }, _toDisplayString(error), 1))
        }), 128))
      ]),
      _createElementVNode("div", null, [
        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block font-semibold text-slate-700 mb-2 text-sm sm:text-base" }, [
          _createTextVNode(" Precio "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 text-slate-500 text-sm sm:text-base" }, "S/", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((precioProductoLocal).value = $event)),
            onBlur: _cache[7] || (_cache[7] = ($event: any) => (emit('blur', 'precio'))),
            type: "number",
            step: "0.01",
            class: "w-full pl-8 sm:pl-10 pr-3 sm:pr-4 py-2 sm:py-2.5 text-sm sm:text-base border-2 rounded-lg sm:rounded-xl focus:border-red-500 focus:outline-none transition-colors",
            placeholder: "0.00"
          }, null, 544), [
            [
              _vModelText,
              precioProductoLocal.value,
              void 0,
              { number: true }
            ]
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.validaciones.precio, (error) => {
          return (_openBlock(), _createElementBlock("p", {
            key: error,
            class: "text-red-500 text-xs sm:text-sm mt-1"
          }, _toDisplayString(error), 1))
        }), 128))
      ]),
      _createElementVNode("div", null, [
        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block font-semibold text-slate-700 mb-2 text-sm sm:text-base" }, [
          _createTextVNode(" Stock "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((stockProductoLocal).value = $event)),
          onBlur: _cache[9] || (_cache[9] = ($event: any) => (emit('blur', 'stock'))),
          type: "number",
          class: "w-full px-3 sm:px-4 py-2 sm:py-2.5 text-sm sm:text-base border-2 rounded-lg sm:rounded-xl focus:border-red-500 focus:outline-none transition-colors",
          placeholder: "0"
        }, null, 544), [
          [
            _vModelText,
            stockProductoLocal.value,
            void 0,
            { number: true }
          ]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.validaciones.stock, (error) => {
          return (_openBlock(), _createElementBlock("p", {
            key: error,
            class: "text-red-500 text-xs sm:text-sm mt-1"
          }, _toDisplayString(error), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, [
          _createElementVNode("input", {
            type: "checkbox",
            checked: (isDestacadoLocal.value ?? 0) === 1,
            onChange: _cache[10] || (_cache[10] = ($event: any) => (isDestacadoLocal.value = (isDestacadoLocal.value ?? 0) === 1 ? 0 : 1)),
            class: "sr-only peer"
          }, null, 40, _hoisted_7),
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "w-11 h-6 bg-slate-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-red-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-red-600" }, null, -1)),
          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "ml-3 text-xs sm:text-sm font-medium text-slate-700" }, "⭐ Producto destacado", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block font-semibold text-slate-700 mb-2 text-sm sm:text-base" }, "Descripción", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((descripcionProductoLocal).value = $event)),
          onBlur: _cache[12] || (_cache[12] = ($event: any) => (emit('blur', 'descripcion'))),
          class: "w-full px-3 sm:px-4 py-2 sm:py-2.5 text-sm sm:text-base border-2 rounded-lg sm:rounded-xl resize-none focus:border-red-500 focus:outline-none transition-colors",
          rows: "3",
          placeholder: "Describe el producto en detalle..."
        }, null, 544), [
          [_vModelText, descripcionProductoLocal.value]
        ]),
        _createElementVNode("p", _hoisted_9, _toDisplayString(__props.descripcionProducto.length) + "/500 caracteres ", 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.validaciones.descripcion, (error) => {
          return (_openBlock(), _createElementBlock("p", {
            key: error,
            class: "text-red-500 text-xs sm:text-sm mt-1"
          }, _toDisplayString(error), 1))
        }), 128))
      ])
    ])
  ]))
}
}

})